import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center text-start" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "fs-7 text-muted fw-semobold mt-1"
}

import { computed, inject } from "vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'IbSalesInfo',
  props: {
    side: {},
    rounded: { type: Boolean, default: false },
    size: {},
    isAdmin: { type: Boolean },
    code: {},
    uid: {},
    user: {}
  },
  setup(__props: any) {

const props = __props;



const displayName = computed(
  () => `${props.user.firstName} ${props.user.lastName}`
);

const openUserDetailSider = inject<(partyId: number) => any>(
  InjectKeys.OPEN_USER_DETAILS
);

const onUserClicked = () => {
  if (props.user.partyId) {
    openUserDetailSider?.(props.user.partyId);
  }
};

/*
{
  "firstName": "string",
  "lastName": "string",
  "priorName": "string",
  "birthdate": "string",
  "gender": "string",
  "citizen": "string",
  "ccc": "string",
  "phone": "string",
  "email": "string",
  "address": "string",
  "idFrom": "string",
  "idNumber": "string",
  "idOffice": "string",
  "idIssueDate": "string",
  "idExpiryDate": "string"
}


{
  "nativeName": "string",
  "firstName": "string",
  "lastName": "string",
  "language": "string",
  "timeZone": "string",
  "referCode": "string",
  "countryCode": "string",
  "currency": "string",
  "ccc": "string",
  "birthday": "2023-08-03",
  "gender": 0,
  "citizen": "string",
  "address": "string",
  "idType": 0,
  "idNumber": "string",
  "idIssuer": "string",
  "idIssuedOn": "2023-08-03",
  "idExpireOn": "2023-08-03"
}
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        href: "#",
        class: "fs-6 text-gray-800 text-hover-primary fw-bold",
        onClick: onUserClicked
      }, [
        _createTextVNode(_toDisplayString(props.user.displayName) + " ", 1),
        (props.code)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "( " + _toDisplayString(props.code) + " )", 1))
          : _createCommentVNode("", true)
      ]),
      (props.uid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " UID: " + _toDisplayString(props.uid), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})